import { OCEANO } from "./oceano";
import { extendPreset } from "./types";

const TURQUOISE = "#0FA3B1";
const CORAL = "#FF6F59";
const CORAL_RGB = "255, 111, 89";

/**
 * "Recife" preset: vibrant turquoise and coral, rounder and playful
 */
export const RECIFE = extendPreset(OCEANO, {
  id: "recife",
  defaults: {
    source: TURQUOISE,
    variant: "vibrant",
  },
  preview: {
    background: "#E6FAF8",
    surface: "#FFFFFF",
    primary: TURQUOISE,
    accent: CORAL,
  },
  accent: CORAL,
  surfaceChroma: 10,
  radiusScale: 1.25,
  gradients: {
    auth: `linear-gradient(135deg, ${TURQUOISE} 0%, #3DCCC7 45%, ${CORAL} 100%)`,
  },
  components: {
    nav: {
      "server-radius": "12px",
      "server-radius-hover": "9px",
      unread: CORAL,
      "badge-bg": CORAL,
      "badge-fg": "#FFFFFF",
    },
    message: {
      "mention-bg": `rgba(${CORAL_RGB}, 0.16)`,
      "mention-bar": CORAL,
      "new-line": CORAL,
      "new-bg": CORAL,
      "new-fg": "#FFFFFF",
    },
    quote: {
      "nested-bg": `rgba(${CORAL_RGB}, 0.14)`,
      "nested-bar": CORAL,
    },
    call: {
      speaking: CORAL,
    },
  },
});
